// Video autoplay, the Fancybox lightbox and the HubSpot pixel.

// Video.razor: start playing once half the video is on screen. Browsers that refuse
// autoplay get the play button instead.
window.playvideo = (id) => {
    const elm = document.getElementById('video-' + id);
    const btn = document.getElementById('playbutton-' + id);
    const icon = document.getElementById('playbutton-icon-' + id);
    if (!elm || !btn || !icon) {
        return;
    }

    const play = (e) => {
        e.preventDefault();
        elm.play();
        icon.style.display = 'none';
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            }
            const video = entry.target;
            video.play().then(() => {
                video.controls = false;
                icon.style.display = 'none';
            }).catch(() => {
                icon.style.display = 'block';
                btn.addEventListener('click', play);
                btn.addEventListener('touchend', play);
            });
            observer.unobserve(video); // only the first time
        });
    }, { threshold: 0.5 });

    observer.observe(elm);
};

// Fancybox is about a third of the script weight and only a few articles use it, so it is
// fetched when the magazine actually has a lightbox in it.
mag.fancybox = null;

mag.initLightbox = (session) => {
    if (!document.querySelector('[data-fancybox]')) {
        return;
    }

    // A click that beats the download would follow the link itself (the raw video file),
    // so hold it and replay it once Fancybox is there to catch it.
    let ready = false;
    document.addEventListener('click', (e) => {
        const trigger = e.target instanceof Element ? e.target.closest('[data-fancybox]') : null;
        if (!trigger || ready) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        mag.fancybox?.then(() => trigger.click());
    }, { capture: true, signal: session.signal });

    mag.fancybox ??= new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `js/fancybox.umd.js?v=${mag.version ?? ''}`;
        script.onload = () => resolve(window.Fancybox);
        script.onerror = reject;
        document.head.appendChild(script);
    });
    // bind() delegates from the document, so binding again after a re-run is harmless
    mag.fancybox.then(Fancybox => {
        Fancybox.bind('[data-fancybox]', {});
        ready = true;
    }).catch(() => {
        // without the script the links behave as plain links
        ready = true;
    });
};

window.addHubSpotPixel = () => {
    const script = document.createElement('script');
    script.src = '//js.hs-scripts.com/4658443.js';
    script.type = 'text/javascript';
    script.async = true;
    script.id = 'hs-script-loader';
    script.defer = true;
    document.body.appendChild(script);
};
